import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { scrollToId } from "../../utils/motion";
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  href: string;
  size?: "md" | "lg";
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  href,
  size = "lg",
  pulse = true,
  className = ""
}: CtaButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      scrollToId(href.slice(1));
    }
  };
  return <motion.a href={href} onClick={handleClick} animate={pulse ? {
    scale: [1, 1.025, 1]
  } : undefined} transition={pulse ? {
    duration: 1.8,
    repeat: Infinity,
    ease: "easeInOut"
  } : undefined} whileTap={{
    scale: 0.97
  }} className={`group relative isolate inline-flex w-full items-center justify-center overflow-hidden rounded-2xl border-b-4 border-berry-dark bg-berry text-center text-white shadow-[0_18px_40px_-12px_rgba(199,37,78,0.65)] transition-colors duration-150 ease-out hover:bg-[#B21F45] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-light ${size === "lg" ? "px-6 py-5 sm:px-10" : "px-6 py-4"} ${className}`} data-id="element-592" data-mp="1d4zm87myq7ba">
      <motion.span aria-hidden className="pointer-events-none absolute inset-y-0 -left-1/3 -z-10 w-1/4 skew-x-[-20deg] bg-white/25" animate={{
      x: ["0%", "600%"]
    }} transition={{
      duration: 1.6,
      repeat: Infinity,
      repeatDelay: 2.2,
      ease: "linear"
    }} data-id="element-593" data-mp="2liob8uxp867z" />
      <span className="flex flex-col items-center" data-id="element-594" data-mp="27in8f9xviopv">
        <span className={`flex items-center gap-2 font-extrabold uppercase tracking-wide ${size === "lg" ? "text-base sm:text-xl" : "text-sm sm:text-base"}`} data-id="element-595" data-mp="27jf56o37ishq">
          {label}
          <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-596" data-mp="1f0j8rl7qkg7k" />
        </span>
        {sublabel && <span className="mt-1 flex items-center gap-1.5 text-xs font-medium text-white/85 sm:text-sm" data-id="element-597" data-mp="3a4heddn5b0fo">
            <LockIcon className="h-3.5 w-3.5" data-id="element-598" data-mp="3f3as976cgtgd" />
            {sublabel}
          </span>}
      </span>
    </motion.a>;
}